<template>
  <v-row no-gutters>
    <v-col cols="12" md="12" class="pt-2 pl-2 pr-2">
      <v-text-field
        :loading="loading"
        append-inner-icon="mdi-magnify"
        density="compact"
        label="Search"
        variant="outlined"
        hide-details
        v-model="txtSearch"
        @input="inputSearch()"
      ></v-text-field>
    </v-col>
    <v-col
      cols="12"
      md="12"
      class="mt-2 pl-2 pr-2"
      v-for="(item, index) in pgList"
      :key="index"
      :style="{
        backgroundColor:
          item.pageId == selectedOne.pageId ? '#def3ff' : 'transparent',
      }"
      @click="selectedOne = item"
    >
      <!-- <v-card variant="outlined" "> -->
      <v-menu v-model="menu">
        <template v-slot:activator="{ props }">
          <span v-bind="props">
            <v-row
              no-gutters
              class="pl-2 pt-2 pr-2"
              @click.left.prevent="clickPage(item, 1)"
              @click.right.prevent="menuDialog(item)"
            >
              <v-col cols="3" md="3">
                <span>
                  <img :src="srcMethod(item.photo)" height="70vh" width="70vh"
                /></span>
              </v-col>
              <v-col cols="9" md="9">
                <v-row no-gutters>
                  <v-col cols="9" md="8">
                    <span
                      ><h4>{{ item.title }}</h4></span
                    >
                  </v-col>
                  <v-col cols="3" md="4">
                    <span class="text-right"
                      ><h6>{{ item.messageDate }}</h6></span
                    >
                  </v-col>
                  <v-col cols="10" md="10">
                    <div
                      class="cut-text text-caption"
                      v-if="item.sendMessage != ''"
                    >
                      {{ item.sendMessage }}
                    </div>
                    <div class="text-caption" v-else>Photo message</div>
                  </v-col>
                  <v-col cols="2" md="2" v-if="item.look!=0">
                    <center>
                      <v-btn variant="tonal" size="x-small" flat icon  ><h4>{{ item.look }}</h4></v-btn>
                    </center>
                    </v-col>
                </v-row>
              </v-col>
            </v-row>
          </span>
        </template>

        <v-list
          density="compact"
          v-if="
            menu &&
            menuSelected.pageId == item.pageId &&
            loginUser.role == 'CUSTOMER'
          "
        >
          <v-list-item
            v-for="(menuObj, i) in rightMenuList"
            :key="i"
            @click="clickPageUnLike(item)"
          >
            <!-- <template v-slot:prepend>
              <v-icon :icon="item.icon" size="x-small"></v-icon>
            </template> -->
            <v-list-item-title density="compact">{{
              menuObj.title
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- </v-card> -->
    </v-col>
  </v-row>
</template>
<script>
import pgService from "../service/PageService";
import axios from "../config";
export default {
  data: () => ({
    selectedOne: {},
    pgList: [],
    tempPageList: [],
    menu: false,
    rightMenuList: [],
    menuSelected: {},
    loginUser: {},
    customerOrPage: "C",
    loading: false,
    txtSearch: "",
    indexOne: 0,
  }),
  props: {},
  mounted: function () {
    this.loginUser = this.$store.state.userAccountChat;
    this.customerOrPage = this.$store.state.customerOrPage;
    this.selectedOne = this.$store.state.page;
    this.pageListMethod();

    this.disconnect();
    this.connection();
  },
  methods: {
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
      this.connected = false;
    },
    connection() {
      this.connected ? this.disconnect() : this.connect();
    },
    connect() {
      let socket = new SockJS("/chat");
      this.stompClient = Stomp.over(socket);
      this.stompClient.connect(
        {},
        (frame) => {
          this.connected = true;
          this.stompClient.subscribe("/mbt/friends/active", (response) => {
            let userObj = JSON.parse(response.body);
            if (userObj.webSocket == "M") {

              if(userObj.userAccountDto!=null) {
                if(userObj.userAccountDto.userAccountId!=this.loginUser.userId){
              for (let i = 0; i < this.pgList.length; i++) {
                var obj = this.pgList[i];
                if (
                  obj.pageId == userObj.pageDto.pageId
                ) {
                    obj.sendMessage = userObj.sendMessage;
                    obj.messageDate = userObj.time;
                    obj.look = Number(obj.look) + 1;
                }
              }
            }
            }else{
              for (let i = 0; i < this.pgList.length; i++) {
                  let obj = this.pgList[i];
                  if (obj.pageId == userObj.pageDto.pageId) {
                    obj.look = Number(0);
                  }
                }
            }


            }
          });
        },
        (error) => {
          this.connected = false;
        }
      );
    },
    inputSearch: function () {
      this.indexOne = 0;
      window.setTimeout(() => {
        if (this.indexOne == 0) {
          this.indexOne = 1;
          if (this.txtSearch.trim() != "") {
            this.searchMethod();
          } else {
            this.pgList.splice(0);
            this.pgList.push(...this.tempPageList);
          }
        }
      }, 500); // interval set to one sec.
    },
    searchMethod: function () {
      this.pgList.splice(0);
      this.loading = true;
      for (let i = 0; i < this.tempPageList.length; i++) {
        let obj = this.tempPageList[i];
        if (
          obj.title
            .toLowerCase()
            .trim()
            .includes(this.txtSearch.toLowerCase().trim())
        ) {
          this.pgList.push(obj);
        }
      }
      this.loading = false;
    },
    clickPageUnLike: function (item) {
      pgService
        .deletePageUser(item)
        .then((response) => {
          this.pageListMethod();
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
    },
    menuDialog: function (item) {
      this.rightMenuList.splice(0);
      this.rightMenuList.push({
        title: "Delete",
      });
      this.menu = true;
      this.menuSelected = Object.assign({}, item);
    },
    clickPage: function (item, index) {
      //item.look = 0;
      this.selectedOne = Object.assign({}, item);
      this.menuSelected = {};
      this.menu = false;

      this.$emit("pageMethod", item, index);
    },
    srcMethod: function (pictureCode) {
      return `${axios.defaults.baseURL}/pagephoto/${pictureCode}.png`;
    },
    pageListMethod: function () {
      pgService
        .getPage(this.customerOrPage)
        .then((response) => {
          this.pgList.splice(0, this.pgList.length);
          this.pgList.push(...response);
          this.tempPageList.splice(0);
          this.tempPageList.push(...response);
          if (this.pgList.length > 0) {
            if (this.selectedOne.pageId == undefined) {
              this.selectedOne = this.pgList[0];
            }
            this.clickPage(this.selectedOne, 0);
          } else {
            this.$router.push("/search").catch(() => {});
          }
        })
        .catch((error) => {
          //this.$swal("Fail!", error.response.data.message, "error");
        });
    },
  },
  watch: {},
  components: {},
};
</script>
<style scoped>
.cut-text {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 250px;
  height: 2em;
  white-space: nowrap;
}
</style>